const CHARSET =
  'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

export const randomString = (length: number) =>
  Array(length)
    .join()
    .split(',')
    .map(() => CHARSET.charAt(Math.floor(Math.random() * CHARSET.length)))
    .join('');
